export default (componentId = 'drag-drop-default') => ({
    drop: false,
    componentId,

    init() {
        let timeout = null

        if (this.disabled) {
            return;
        }

        this.$el.addEventListener('dragover', (event) => {
            event.stopPropagation();
            event.preventDefault();
            clearTimeout(timeout)
            this.drop = true;
        })
        this.$el.addEventListener('dragleave', (event) => {
            event.stopPropagation();
            event.preventDefault();
            timeout = setTimeout(() => this.drop = false, 100)
        })
        this.$el.addEventListener('drop', (event) => {
            event.stopPropagation();
            event.preventDefault();

            // Scoped per attachment bucket — plain Files dispatch hit every listener using `.window`.
            this.$dispatch('get-files-from-draganddrop', {
                componentId: this.componentId,
                files: event.dataTransfer.files,
            })
            this.drop = false
        })
    }
})
